import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Inject } from '@angular/core';

import { IS_MOBILE } from '@app/modules/core/tokens/app.tokens';
import { TravelDetailProvider } from '@shared/flight-itinerary/entities/travel-detail-provider';
import { BusClassTypes } from '@buses/bus-results/entities/bus-type';
import { OptionVm, Bus } from '@app/entities/bus-results';

@Component({
  selector: 'app-bus-route-detail',
  templateUrl: './bus-route-detail.component.html',
  styleUrls: ['./bus-route-detail.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BusRouteDetailComponent {

  @Input() routeInfo: OptionVm;
  @Input() busKeys: string = '';
  @Input() busClass: BusClassTypes;
  @Input() provider: string;

  public flightInfoProvider: TravelDetailProvider = TravelDetailProvider.BUS_RESULTS;

  constructor(
    @Inject(IS_MOBILE) public isMobile: boolean,
  ) { }

  public isScaleElement(item: number): boolean {
    return item < this.routeInfo.Flights.length - 1;
  }

  get hasScales(): boolean {
    return this.routeInfo.Flights.length - 1 > 0;
  }

  public getBusKey(index: number): string {
    const keys = this.busKeys ? this.busKeys.trim().split(',') : [];
    return keys.length > 0 ? keys[index] : '';
  }

  public bustItem(item: number): Bus {
    return this.routeInfo.Flights[item];
  }

  public nextBusItem(item: number): Bus {
    return this.routeInfo.Flights[item + 1] || {} as Bus;
  }

  public busItem(item: number): Bus {
    return this.routeInfo.Flights[item];
  }

  public nextFlightItem(item: number): Bus {
    return this.routeInfo.Flights[item + 1] || {} as Bus;
  }

}
